/* ABC Teknikk - Cloudflare Turnstile for moteromsvelger-skjemaet.
 * Laster Turnstile, holder et gyldig token, og legger det pa lead-innsendingen
 * til n8n. Rorer ikke React-appen (moteromsvelger.js).
 */
(function () {
  var SITEKEY = "0x4AAAAAADelwW9v9BF7tTUT";
  var ENDPOINT = "https://wud.app.n8n.cloud/webhook/8a8a4265-f388-4ea8-af8f-c2d320c1d95e";
  var token = "";
  var widgetId = null;

  function host() {
    var el = document.getElementById("mtv-turnstile-host");
    if (el) return el;
    el = document.createElement("div");
    el.id = "mtv-turnstile-host";
    el.style.position = "fixed";
    el.style.right = "16px";
    el.style.bottom = "16px";
    el.style.zIndex = "2147483647";
    (document.body || document.documentElement).appendChild(el);
    return el;
  }

  function render() {
    if (widgetId !== null || !window.turnstile) return;
    try {
      widgetId = window.turnstile.render(host(), {
        sitekey: SITEKEY,
        action: "moteromsvelger_lead",
        appearance: "interaction-only",
        callback: function (t) { token = t; },
        "expired-callback": function () {
          token = "";
          try { window.turnstile.reset(widgetId); } catch (e) {}
        },
        "error-callback": function () { token = ""; }
      });
    } catch (e) {}
  }

  function currentToken() {
    if (token) return token;
    try {
      if (window.turnstile && widgetId !== null) return window.turnstile.getResponse(widgetId) || "";
    } catch (e) {}
    return "";
  }

  var s = document.createElement("script");
  s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  s.async = true;
  s.defer = true;
  s.onload = render;
  (document.head || document.documentElement).appendChild(s);

  if (typeof window.fetch === "function") {
    var orig = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (url.indexOf(ENDPOINT) === 0 && init && typeof init.body === "string") {
          var data = JSON.parse(init.body);
          if (data && data.source === "moteromsvelger") {
            var tk = currentToken();
            if (!tk) {
              return Promise.reject(new Error("Vi bekrefter at du er et menneske. Vent et øyeblikk og prøv igjen."));
            }
            data.turnstileToken = tk;
            init = Object.assign({}, init, { body: JSON.stringify(data) });
            token = "";
            try { if (window.turnstile && widgetId !== null) window.turnstile.reset(widgetId); } catch (e) {}
          }
        }
      } catch (e) {}
      return orig(input, init);
    };
  }
})();
